import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-radio-button',
    templateUrl: './sera-radio-button.component.html',
    styleUrls: ['./sera-radio-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraRadioButtonComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraRadioButtonComponent extends ValueAccessor<any> {
    @Input()
    isDisabled: boolean = false;

    @Input()
    radioButtonGroupId: string = 'radioGroup';

    @Input()
    style: {} = {};

    @Input()
    options!: any[];

    @Input()
    label: string | undefined;

    @Input()
    inputStyle: string = '';

    @Input()
    readOnly: boolean = false;

    @Output() selectionChanged = new EventEmitter<string>();

    constructor(injector: Injector) {
        super(injector);
    }
}
